import { RESOURCE_TYPE } from '../constants';

const buildResourceExpression = (data, resourceType) => {
  switch (resourceType) {
    case RESOURCE_TYPE.CHASSIS:
      return [
        `org:tml:resource:chassis:plant:${data.plant}:line:${data.line}:fbv:*`,
      ];
    case RESOURCE_TYPE.AGGREGATE:
      return [
        `org:tml:resource:aggregate:plant:${data.plant}:line:${data.line}:fbv:*`,
      ];
    case RESOURCE_TYPE.MATERIAL:
      return [
        `org:tml:resource:material:plant:${data.plant}:line:${data.line}`,
      ];
    case RESOURCE_TYPE.PLANT:
      return [`org:tml:resource:plant:${data.plant}`];
    case RESOURCE_TYPE.PRODUCTION_STATISTICS:
      return [`org:tml:resource:production-statistics`];
    case RESOURCE_TYPE.DISPLAYABLE_SHOP:
      return [
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:*`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:Chassis`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:Frame`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:BIW`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:Cab`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:Engine`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:Front Axle`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:Gear box`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:Paint`,
        `org:tml:resource:displayable-shop:plant:${data.plant}:shop_type:Rear Axle`,
        `*`,
      ];
    case RESOURCE_TYPE.DISPLAYABLE_SCM_MATERIAL_TAB:
      return [
        `org:tml:resource:displayable-scm-material-tab:plant:${data.plant}`,
      ];
    case RESOURCE_TYPE.MASTER_SHIFT:
      return [
        `org:tml:resource:master-shift:plant:${data.plant}`
      ]
    case RESOURCE_TYPE.EVR_QUANTITY:
        return [`org:tml:resource:evr-quantity`];
    default:
      return '';
  }
};

export const getAllowedOperations = (
  plant,
  line,
  resourceTypes,
  authPolicies,
) => {
  let evaluatedOperationsForAllResourceTypes = [];
  resourceTypes.forEach(resourceType => {
    const resourceExpressions = buildResourceExpression(
      {
        plant: plant.value,
        line: line.value,
      },
      resourceType,
    );
    const evaluatedOperations = authPolicies.reduce((acc, policy) => {
      resourceExpressions.forEach(item => {
        let matchedExpression = null;
        const matches = policy.allowed.some(expression => {
          const isMatch = resourceExpressionsMatch(expression, item);
          if (isMatch) matchedExpression = expression;
          return isMatch;
        });
        if (matches) {
          acc.push({
            operation: policy.operation,
            value: matchedExpression,
          });
        }
      });
      return acc;
    }, []);
    evaluatedOperationsForAllResourceTypes.push(...evaluatedOperations);
  });
  return evaluatedOperationsForAllResourceTypes;
};

export const resourceExpressionsMatch = (expression1, expression2) => {
  return (
    expression1 === expression2 ||
    matchBasedOnWildcard(expression1, expression2)
  );
};

const matchBasedOnWildcard = (expression1, expression2) => {
  const expression1Elements = elements(expression1);
  const expression2Elements = elements(expression2);
  return (
    commonElementsMatch(expression1Elements, expression2Elements) &&
    uncommonElementsMatch(expression1Elements, expression2Elements)
  );
};

const elements = target => target.split(':');

const commonElementsMatch = (expression1Elements, expression2Elements) => {
  return [
    ...Array(
      Math.min(expression1Elements.length, expression2Elements.length),
    ).keys(),
  ].every(index =>
    elementMatch(expression1Elements[index], expression2Elements[index]),
  );
};

const uncommonElementsMatch = (expression1Elements, expression2Elements) => {
  const expression1Size = expression1Elements.length;
  const expression2Size = expression2Elements.length;
  const indexOfLastComparableElement =
    Math.min(expression1Size, expression2Size) - 1;
  return (
    expression1Size === expression2Size ||
    (expression1Size > expression2Size &&
      isWildcard(expression2Elements[indexOfLastComparableElement])) ||
    (expression2Size > expression1Size &&
      isWildcard(expression1Elements[indexOfLastComparableElement]))
  );
};

const elementMatch = (element1, element2) => {
  return element1 === element2 || isWildcard(element1) || isWildcard(element2);
};

const isWildcard = element => element === '*';
